(() => {
  'use strict';
  if (window.__bbSearchAnalytics) return;
  const config = document.querySelector('script[data-bb-search-analytics]');
  if (!config) return;
  const debug = new URLSearchParams(location.search).get('bb_search_debug') === '1';
  const preview = window.Shopify?.designMode || (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') || new URLSearchParams(location.search).has('preview_theme_id');
  const api = { version: '1.1.0', events: [] };
  window.__bbSearchAnalytics = api;
  if (preview && !debug) return;
  const KEY = 'bb-search-attempt-v1';
  const TTL = 30 * 60 * 1000;
  const forms = new WeakMap();
  const resultObservers = new WeakMap();
  const seen = new Set();
  const pending = [];
  let active;
  let lastKey = 0;
  let lastPointer = 0;
  let resultsTracked = false;
  let scanTimer;
  const RESULTS_SELECTOR = '.cc-main-search #filter-results, .cc-main-search .main-products-grid__results, #filter-results';
  const normalise = value => String(value || '').trim().replace(/\s+/g, ' ').toLowerCase().slice(0, 100);
  const valid = value => Array.from(value).length >= 3 && !/[^\s@]+@[^\s@]+\.[^\s@]+/.test(value);
  const allowed = () => {
    try { return typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function' || window.Shopify.customerPrivacy.analyticsProcessingAllowed(); } catch (_) { return false; }
  };
  const path = value => {
    try { return new URL(value, location.origin).pathname.replace(/\/$/, '') || '/'; } catch (_) { return ''; }
  };
  const read = () => {
    if (!allowed()) return null;
    try {
      const value = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      return value && valid(value.term) && Date.now() - value.at < TTL ? value : null;
    } catch (_) { return null; }
  };
  const save = value => {
    if (!allowed()) return;
    try { sessionStorage.setItem(KEY, JSON.stringify(value)); } catch (_) { }
  };
  function emit(name, term, extra = {}) {
    if (!valid(term) || !allowed()) return;
    const params = { search_term: term, search_tracking_version: api.version, transport_type: 'beacon', ...extra };
    if (debug) {
      api.events.push({ name, params });
      if (api.events.length > 300) api.events.shift();
      return;
    }
    if (preview) return;
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      else if (pending.length < 100) pending.push({ name, params });
    } catch (_) { }
  }
  function flush() {
    if (!allowed()) { pending.length = 0; return; }
    if (typeof window.gtag !== 'function') return;
    while (pending.length) {
      const event = pending.shift();
      try { window.gtag('event', event.name, event.params); } catch (_) { }
    }
  }
  const bucket = ms => ms < 10000 ? 'under_10s' : ms <= 30000 ? '10_30s' : 'over_30s';
  function attempt(term) {
    if (active && active.term === term) return active;
    if (active && !active.committed) { active.term = term; return active; }
    active = { id: window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`, term, at: Date.now(), committed: false, success: false };
    return active;
  }
  function commit(term, method) {
    const a = attempt(term);
    if (!a.committed) {
      const previous = read();
      const elapsed = previous ? Date.now() - previous.at : Infinity;
      if (previous?.committed && previous.kind !== 'closed' && previous.term !== term && elapsed >= 0 && elapsed < TTL) {
        emit('search_retry', term, { action: bucket(elapsed), interaction_method: previous.kind || 'unknown', previous_search_term: previous.term, link_text: previous.term, elapsed_seconds: Math.round(elapsed / 1000) });
      }
      a.committed = true;
      a.at = Date.now();
      a.kind = method;
      emit('search_attempt', term, { action: method, search_attempt_id: a.id });
    }
    return a;
  }
  function returning(method) {
    const a = read();
    if (!a?.destination || !a.visited || a.returned) return;
    if (method === 'back' && path(location.href) !== a.origin) return;
    const ms = Date.now() - a.at;
    a.returned = true;
    save(a);
    emit('search_return', a.term, { action: bucket(ms), interaction_method: method, link_url: location.origin + a.destination, elapsed_seconds: Math.round(ms / 1000), search_attempt_id: a.id });
  }
  function inputOf(form) { return form?.querySelector('input[name="q"]'); }
  function currentTerm(form) { return normalise(inputOf(form)?.value); }
  function finalise(form) {
    const term = currentTerm(form);
    if (!valid(term) || !active || active.term !== term || active.committed) return;
    const a = commit(term, 'closed');
    save(a);
  }
  function start(form) {
    const term = currentTerm(form);
    if (!valid(term)) return;
    returning('reopen');
    attempt(term);
    scanSuggestions(form);
  }
  function classify(link) {
    const p = path(link.href);
    if (/\/products\/[^/]+$/.test(p)) return 'product';
    if (/\/collections\/[^/]+$/.test(p)) return 'collection';
    if (/\/blogs\/.+\/.+/.test(p)) return 'article';
    if (/\/pages\//.test(p)) return 'page';
    if (/\/search$/.test(p)) return 'query';
    return '';
  }
  function label(link) {
    return (link.querySelector('.predictive-result__title, .product-card__title, .card__title, h3, h2')?.textContent || link.querySelector('span')?.textContent || link.textContent || link.querySelector('img')?.alt || '').trim().replace(/\s+/g, ' ').slice(0, 100);
  }
  function details(link, surface, links) {
    const type = classify(link);
    const position = links.indexOf(link) + 1;
    return {
      action: surface,
      content_type: type,
      link_text: label(link),
      link_url: location.origin + path(link.href),
      link_id: `bb-search-${surface}-${type}-${position}`,
      search_position: position,
      search_surface: surface,
      vendor: link.dataset.bbSearchVendor || ''
    };
  }
  function linksIn(root) {
    const urls = new Set();
    return Array.from(root.querySelectorAll('a[href]')).filter(link => {
      const type = classify(link);
      if (!type || type === 'query') return false;
      const key = path(link.href);
      if (urls.has(key)) return false;
      urls.add(key);
      return true;
    });
  }
  function visible(el) {
    if (document.visibilityState === 'hidden' || !el.getClientRects().length || el.closest('[hidden]')) return false;
    const box = el.getBoundingClientRect();
    return box.width > 0 && box.height > 0 && box.top < innerHeight && box.bottom > 0 && box.left < innerWidth && box.right > 0;
  }
  const itemObservers = new WeakMap();
  function observeLink(link, term, surface, links) {
    const previous = itemObservers.get(link);
    const key = `${term}|${surface}|${path(link.href)}`;
    if (seen.has(key) || previous?.key === key) return;
    previous?.observer.disconnect();
    if (!('IntersectionObserver' in window)) return;
    let timer;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        clearTimeout(timer);
        if (entry.intersectionRatio < 0.5 || !visible(link)) return;
        timer = setTimeout(() => {
          if (surface === 'suggestions') {
            const form = link.closest('form');
            if (currentTerm(form) !== term || !link.closest('predictive-search[open]')) return;
          }
          if (!visible(link) || seen.has(key)) return;
          seen.add(key);
          emit(surface === 'suggestions' ? 'search_suggestion_view' : 'search_result_view', term, details(link, surface, links));
          observer.disconnect();
        }, 250);
      });
    }, { threshold: [0, 0.5] });
    observer.observe(link);
    itemObservers.set(link, { observer, key });
  }
  function suggestionRoot(form) {
    const container = form.querySelector('.js-search-results');
    if (!container) return null;
    return container.querySelector('[data-bb-search-response]') || (
      container.dataset.bbSearchResponseTerm && container.querySelector('a[href], .predictive-search__no-results')
        ? container
        : null
    );
  }
  function suggestionResponseMatches(root, form, term) {
    if (root.dataset.bbSearchResponse) {
      const filter = form.querySelector('[name="filter.p.product_type"]')?.value;
      const expected = filter ? normalise(`product_type:${filter} AND ${term}`) : term;
      return normalise(root.dataset.bbSearchResponse) === expected;
    }
    return normalise(root.dataset.bbSearchResponseTerm) === term;
  }
  function scanSuggestions(form) {
    const term = currentTerm(form);
    const predictive = form.closest('predictive-search');
    if (!valid(term) || !predictive?.hasAttribute('open')) return;
    const root = suggestionRoot(form);
    if (!root || !visible(root) || !suggestionResponseMatches(root, form, term)) return;
    const links = linksIn(root);
    const groupKey = `${term}|suggestions|group`;
    if (!seen.has(groupKey)) {
      seen.add(groupKey);
      emit('search_suggestions_view', term, { action: links.length ? 'results' : 'zero_results', search_result_count: links.length });
      if (!links.length) emit('search_no_suggestions', term, { action: 'suggestions' });
    }
    links.forEach(link => observeLink(link, term, 'suggestions', links));
  }
  function observeResults(root) {
    if (resultObservers.has(root)) return;
    const observer = new MutationObserver(() => {
      clearTimeout(scanTimer);
      scanTimer = setTimeout(scanResults, 150);
    });
    observer.observe(root, { childList: true, subtree: true });
    resultObservers.set(root, observer);
  }
  function scanResults() {
    if (config.dataset.bbSearchPage !== 'search' || config.dataset.bbSearchPerformed !== 'true') return;
    const term = normalise(config.dataset.bbSearchTerm);
    if (!valid(term)) return;
    if (!resultsTracked) {
      const previous = read();
      if (previous?.term === term) active = previous;
      const a = commit(term, 'results_landing');
      if (!a.destination) save(a);
      const count = Number(config.dataset.bbSearchCount || 0);
      emit('search_results_view', term, { action: count === 0 ? 'zero_results' : 'results', search_result_count: count, search_attempt_id: a.id });
      if (count === 0) emit('search_no_results', term, { action: 'results' });
      resultsTracked = true;
    }
    const root = document.querySelector(RESULTS_SELECTOR);
    if (!root) return;
    observeResults(root);
    const links = linksIn(root);
    links.forEach(link => observeLink(link, term, 'results', links));
  }
  function submit(form, method) {
    const term = currentTerm(form);
    if (!valid(term)) return;
    const a = commit(term, method);
    if (a.lastSubmit && Date.now() - a.lastSubmit < 1000) return;
    a.kind = method;
    a.at = Date.now();
    a.lastSubmit = a.at;
    a.origin = path(location.href);
    a.destination = '';
    save(a);
    emit('search_submit', term, { action: 'submit', interaction_method: method, search_attempt_id: a.id });
  }
  function selection(link, form, surface) {
    const term = surface === 'suggestions' ? currentTerm(form) : normalise(config.dataset.bbSearchTerm);
    if (!valid(term)) return;
    const root = surface === 'suggestions' ? suggestionRoot(form) : document.querySelector('#filter-results');
    if (!root) return;
    if (surface === 'suggestions' && !suggestionResponseMatches(root, form, term)) return;
    const links = linksIn(root);
    const canonical = links.find(item => path(item.href) === path(link.href)) || link;
    const info = details(canonical, surface, links);
    const a = commit(term, surface === 'suggestions' ? 'selected_suggestion' : 'selected_result');
    if (a.lastSelection === link.href && Date.now() - a.at < 500) return;
    const method = Date.now() - lastKey < 600 && lastKey > lastPointer ? 'keyboard' : 'pointer';
    emit(surface === 'suggestions' ? 'search_suggestion_select' : 'search_result_select', term, { ...info, interaction_method: method, search_attempt_id: a.id });
    if (!a.success) {
      a.success = true;
      emit('search_success', term, { action: surface, content_type: info.content_type, search_attempt_id: a.id });
    }
    a.kind = surface;
    a.origin = path(location.href);
    a.destination = path(link.href);
    a.at = Date.now();
    a.lastSelection = link.href;
    a.visited = false;
    a.returned = false;
    save(a);
  }
  function formsIn(root) {
    const found = Array.from(root.querySelectorAll?.('form[role="search"]') || []);
    if (root.matches?.('form[role="search"]')) found.unshift(root);
    return found;
  }
  function resultsIn(root) {
    const found = Array.from(root.querySelectorAll?.(RESULTS_SELECTOR) || []);
    if (root.matches?.(RESULTS_SELECTOR)) found.unshift(root);
    return found;
  }
  function cleanup(root) {
    formsIn(root).forEach(form => {
      const state = forms.get(form);
      if (!state) return;
      clearTimeout(state.timer);
      state.resultsObserver?.disconnect();
      state.stateObserver?.disconnect();
      forms.delete(form);
    });
    resultsIn(root).forEach(resultRoot => {
      resultObservers.get(resultRoot)?.disconnect();
      resultObservers.delete(resultRoot);
    });
  }
  function boot(root = document) {
    formsIn(root).forEach(form => {
      if (forms.has(form)) return;
      const input = inputOf(form);
      if (!input) return;
      const state = { timer: null, resultsObserver: null, stateObserver: null };
      forms.set(form, state);
      input.addEventListener('input', () => {
        clearTimeout(state.timer);
        state.timer = setTimeout(() => start(form), 600);
      }, { passive: true });
      input.addEventListener('focus', () => { returning('reopen'); });
      const predictive = form.closest('predictive-search');
      const results = form.querySelector('.js-search-results');
      if (predictive && results) {
        state.resultsObserver = new MutationObserver(() => scanSuggestions(form));
        state.resultsObserver.observe(results, { childList: true, subtree: true });
        state.stateObserver = new MutationObserver(() => {
          if (!predictive.hasAttribute('open')) finalise(form);
          else scanSuggestions(form);
        });
        state.stateObserver.observe(predictive, { attributes: true, attributeFilter: ['open'] });
      }
    });
    scanResults();
  }
  document.addEventListener('pointerdown', () => { lastPointer = Date.now(); }, { capture: true, passive: true });
  document.addEventListener('keydown', event => { if (event.key === 'Enter') lastKey = Date.now(); }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches?.('form[role="search"]') || event.defaultPrevented) return;
    const viewAll = event.submitter?.closest('.predictive-search__view-all, .js-submit');
    submit(form, viewAll ? 'view_all' : Date.now() - lastKey < 600 && lastKey > lastPointer ? 'enter' : 'search_button');
  });
  document.addEventListener('click', event => {
    const control = event.target.closest?.('a[href], button');
    if (!control) return;
    const form = control.closest('form[role="search"]');
    if (form && control.closest('.predictive-search__view-all') && control.matches('a[href]')) { submit(form, 'view_all'); return; }
    if (!control.matches('a[href]')) return;
    if (form && control.closest('.js-search-results')) {
      if (classify(control) === 'query') { submit(form, 'query_suggestion'); return; }
      if (classify(control)) selection(control, form, 'suggestions');
    } else if (config.dataset.bbSearchPage === 'search' && control.closest('#filter-results') && classify(control)) selection(control, null, 'results');
  }, true);
  window.addEventListener('pagehide', () => {
    document.querySelectorAll('form[role="search"]').forEach(finalise);
    flush();
  });
  window.addEventListener('pageshow', event => { if (event.persisted) returning('back'); });
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) {
      active = null;
      pending.length = 0;
      try { sessionStorage.removeItem(KEY); } catch (_) { }
    }
  });
  const previous = read();
  if (previous?.destination) {
    if (path(location.href) === previous.destination) { previous.visited = true; save(previous); }
    else if (path(location.href) === previous.origin) returning('back');
  }
  document.addEventListener('shopify:section:unload', event => { cleanup(event.target); });
  document.addEventListener('shopify:section:load', event => { boot(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  let tries = 0;
  const retry = setInterval(() => { flush(); if (++tries >= 40) clearInterval(retry); }, 250);
})();
